import { LeftColTitle } from 'ide/LeftCol';
import { doc, getFirestore } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { ProOpenaiSplash } from './ProOpenAISplash';
import { ProFirestoreSplash } from './ProFirestoreSplash';

const OptionsSelector = ({ selectedOption, setSelectedOption, options }) => {
  return (
    <select
      className="form-select form-select-sm"
      aria-label="Default select example"
      style={{ width: 200 }}
      value={selectedOption}
      onChange={e => setSelectedOption(e.target.value)}
    >
      {options.map(option => {
        return (
          <option value={option.id} key={option.id}>
            {option.name}
          </option>
        );
      })}
    </select>
  );
};

const ProjectKeysTitle = props => {
  return (
    <div className="d-flex w-100 justify-content-between">
      <span>Project Keys </span>
      <OptionsSelector {...props} />
    </div>
  );
};

export const ProjectKeysSplash = () => {
  // The options for the project keys
  const options = [
    { id: 'openai', name: 'OpenAI' },
    { id: 'firestore', name: 'Firestore' },
  ];
  const [selectedOption, setSelectedOption] = useState('openai');

  // Get the project id from the URL
  const { urlKey } = useParams();

  // A reference to the projectKeys document for this project
  const [projectKeysRef, setProjectKeysRef] = useState(null);

  // Load the projectKeysRef and project keys when the component mounts
  useEffect(() => {
    try {
      // Initialize a reference to the project keys document
      const db = getFirestore();
      const projectKeysRef = doc(db, 'projectKeys', urlKey);
      setProjectKeysRef(projectKeysRef);
    } catch (error) {
      console.error('Error loading project keys: ', error);
    }
  }, []);

  return (
    <>
      <LeftColTitle
        title={
          <ProjectKeysTitle
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            options={options}
          />
        }
      />
      {/* Show the selected option and pass in the project keys ref */}
      {selectedOption === 'openai' ? (
        <ProOpenaiSplash projectKeysRef={projectKeysRef} />
      ) : (
        <ProFirestoreSplash />
      )}
    </>
  );
};
